{
  "min": 50,
  "max": 1000,
  "R": [98, 210, 169, 128, 255],
  "G": [94, 26, 77, 128, 255],
  "B": [45, 21, 74, 128, 255],
  "A": [0, 25, 0, 4, 168],
  "I": [0, 41, 87, 154, 255]
}
